import { render, staticRenderFns } from "./ButtonConfig.vue?vue&type=template&id=6e7273f4&scoped=true"
import script from "./ButtonConfig.vue?vue&type=script&lang=js"
export * from "./ButtonConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7273f4",
  null
  
)

export default component.exports